// extracted by mini-css-extract-plugin
export default {"main-logo":"Logo_main-logo__hXVEi","mobile-logo":"Logo_mobile-logo__xpx-U","footer-logo":"Logo_footer-logo__US+Eh"};